import React from 'react';
import DOMPurify from 'dompurify';
import LocalizedLink from 'helpers/LocalizeLink';
import { useTranslation } from 'react-i18next';
import { getFormattedDate } from 'helpers/util';
import { useSelector } from 'react-redux';
import { AddToCart,CheckoutButton } from 'helpers/cart/AddToCart';

const ChallengeWidget = (props) => {
    const { t } = useTranslation()
    const currency = useSelector(store => store.currency)

    const getDate = (date) => {
        return getFormattedDate(date)
    }

    const getTimeLift = (date) => {
        return null
    }

    const getItem = () => {
        const item_new = {
            assets: props.assets,
            datamin: props.datamin,
            deploy_at: props.deploy_at,
            description: props.description,
            developer_mode: props.developer_mode,
            id: props.id,
            status: props.status,
            img: props.img,
            is_auto_close: props.is_auto_close,
            leverage: props.leverage,
            long_trades: props.long_trades,
            min_trades: props.min_trades,
            name: props.name,
            participants_number: props.participants_number,
            participants_total: props.participants_total,
            path: props.path,
            position: props.position,
            price: props.price,
            reward: props.reward,
            reward1ST: props.reward1ST,
            reward2ST: props.reward2ST,
            reward3ST: props.reward3ST,
            short_trades: props.short_trades,
            start_at: props.start_at,
            stop_at: props.stop_at,
            stop_loss: props.stop_loss,
            take_profit: props.take_profit,
            type: props.type,
            used_candle_patterns: props.used_candle_patterns,
            used_indicators: props.used_indicators,
        }
        return item_new
    }

    return (
        <div>
            <div>
                <LocalizedLink to={'challenges'}>
                    {t('buttons.btn_back_challenges')}</LocalizedLink>
                <p>{props.name}</p>
                <div>
                    <div>
                        <p>
                            <span>{t('filter.labels.high_reward')}: {props.options.reward1ST} {currency.symbol}</span>
                            <span>{props.participants_total}/{props.options.participants_number} {t('labels.participants')}</span>
                        </p>
                        <img alt={props['name']} src={props.img} />
                    </div>
                    <div>
                        <p>{t('challenge.description')}:</p>
                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.description) }}></p>
                        <div>
                            <div>
                                <span>{props['price']} {currency.symbol}</span>
                                <AddToCart item={getItem()} index={0}></AddToCart>
                            </div>
                            <CheckoutButton item={getItem()}/>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <p>{t('labels.dates')}</p>
                        <div>
                            <p>{t("challenge.time_left")}</p>
                            <span>{getTimeLift(props['start_at'])}</span>
                        </div>
                        <div>
                            <p>{t("challenge.start_at")}</p>
                            <span>{getDate(props['start_at'])}</span>
                        </div>
                        <div>
                            <p>{t("challenge.stop_at")}</p>
                            <span>{getDate(props['stop_at'])}</span>
                        </div>
                        <div>
                            <p>{t("challenge.deploy_at")}</p>
                            <span>{getDate(props['deploy_at'])}</span>
                        </div>
                    </div>
                    <div>
                        <p>{t('labels.rewards')}</p>
                        <div>
                            <p>{t("challenge.reward1ST")}</p>
                            <span>{props.options.reward1ST} {currency.symbol}</span>
                        </div>
                        <div>
                            <p>{t("challenge.reward2ST")}</p>
                            <span>{props.options.reward2ST} {currency.symbol}</span>
                        </div>
                        <div>
                            <p>{t("challenge.reward3ST")}</p>
                            <span>{props.options.reward3ST} {currency.symbol}</span>
                        </div>
                        <div>
                            <p>{t("challenge.win_text")}</p>
                            <span>{props.data.win_text}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <p>{t('labels.restrictions')}</p>
                    <div>
                        <p>{t("challenge.used_indicators")}</p>
                        <span>{props.options.used_indicators}</span>
                    </div>
                    <div>
                        <p>{t("challenge.used_candle_patterns")}</p>
                        <span>{props.options.used_candle_patterns}</span>
                    </div>
                    <div>
                        <p>{t("challenge.assets")}</p>
                        <span>{props.options.assets}</span>
                    </div>
                    <div>
                        <p>{t("challenge.take_profit")}</p>
                        <span>{props.options.take_profit?t('labels.yes'):t('labels.no')}</span>
                    </div>
                    <div>
                        <p>{t("challenge.stop_loss")}</p>
                        <span>{props.options.stop_loss?t('labels.yes'):t('labels.no')}</span>
                    </div>
                    <div>
                        <p>{t("challenge.long_trades")}</p>
                        <span>{props.options.long_trades?t('labels.yes'):t('labels.no')}</span>
                    </div>
                    <div>
                        <p>{t("challenge.short_trades")}</p>
                        <span>{props.options.short_trades?t('labels.yes'):t('labels.no')}</span>
                    </div>
                    <div>
                        <p>{t("challenge.CHA_FSBA")}</p>
                        <span>{props['CHA_FSBA']}</span>
                    </div>
                </div>
                <div>
                    <div>
                        <p>{t("challenge.leverage")}</p>
                        <span>{props.options.leverage?t('labels.yes'):t('labels.no')}</span>
                    </div>
                    <div>
                        <p>{t("challenge.CHA_NUMBBACK")}</p>
                        <span>{props['CHA_NUMBBACK']}</span>
                    </div>
                    <div>
                        <p>{t("challenge.min_trades")}</p>
                        <span>{props['min_trades']}</span>
                    </div>
                    <div>
                        <p>{t("challenge.developer_mode")}</p>
                        <span>{props['developer_mode']}</span>
                    </div>
                    <div>
                        <p>{t("challenge.CHA_AIPP")}</p>
                        <span>{props.options.leverage?t('labels.yes'):t('labels.no')}</span>
                        <span>{props['CHA_AIPP']}</span>
                    </div>
                    <div>
                        <p>{t("challenge.CHA_AIPR")}</p>
                        <span>{props.options.leverage?t('labels.yes'):t('labels.no')}</span>
                        <span>{props['CHA_AIPR']}</span>
                    </div>
                    <div>
                        <p>{t("challenge.datamin")}</p>
                        <span>{props.datamin}</span>
                    </div>
                    <div>
                        <p>{t("challenge.is_auto_close")}</p>
                        <span>{props.options.is_auto_close?t('labels.yes'):t('labels.no')}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChallengeWidget;
